import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ColDef, GridOptions,RowNode,GridApi, ModuleRegistry } from 'ag-grid-community';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { formatText } from 'src/app/shared/commen-function-file';
@Component({
  selector: 'app-reusable-table',
  templateUrl: './reusable-table.component.html',
  styleUrls: ['./reusable-table.component.scss'],
})
export class ReusableTableComponent implements OnInit, OnChanges {
  document = document;
  @Input() parentHeaders: { key: string; label: string }[] = [
    { key: 'assetName', label: 'Asset Name' },
    { key: 'band', label: 'Band' },
    { key: 'allocatingAuthorityName', label: 'Allocating Authority' },
  ];

  gridApi!: GridApi;                 // holds AG Grid API reference
  isFinanceLoginUser = false;        // replace with actual logic if needed
  financeIdForEmployee = -1;
  searchTaskString = '';
  paginationPageSizeSelector = [5, 10, 20,50,100,200,500,1000];
  pagination = true;
  paginationPageSize = 10;
  formatedataVariable = formatText;
  
  onGridReady(params: any) {
    // ✅ store gridApi for later use
    this.gridApi = params.api;

    // ✅ expand all rows (your existing logic)
    params.api.forEachNode((node: RowNode) => node.setExpanded(true));
  }



  openCommentModal(text: string, commentType: string) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType
      }
    });

  }
  constructor(private dialog: MatDialog) { }




  @Input() nestedHeaders = [
    { key: 'employeeName', label: 'Employee Name' },
    { key: 'band', label: 'Band' },
    { key: 'authorityDepartment', label: 'Authority Dept' },
    { key: 'allocatingAuthorityName', label: 'Authority Name' },
    { key: 'dateOfAllocation', label: 'Allocation Date' },
    { key: 'currentAssetDescription', label: 'Current Asset Description' },
    { key: 'employeeAssetStatus', label: 'Employee Status' },
    { key: 'employeeComment', label: 'Employee Comment' },
    { key: 'employeeCommentDate', label: 'Employee Comment Date' },
    { key: 'authorityDepartmentComment', label: 'HR ADMIN/Allocating Authority Comment' },
    { key: 'authorityCommentDate', label: 'Authority Comment Date' },
    { key: 'assetRepairTime', label: 'Asset Repair Time' },
    { key: 'action', label: 'Action' },
  ];
  dateRenderer(params: any) {
    if (!params.value) return '';

    const value = params.value;

    // If already a Date object
    if (value instanceof Date) {
      const day = String(value.getDate()).padStart(2, '0');
      const month = String(value.getMonth() + 1).padStart(2, '0');
      const year = value.getFullYear();
      return `${day}-${month}-${year}`;
    }

    // If string in dd-mm-yyyy format
    if (typeof value === 'string' && value.includes('-')) {
      const parts = value.split('-');
      if (parts[0].length === 4) {
        // yyyy-mm-dd
        const date = new Date(value);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      } else {
        // dd-mm-yyyy
        const [day, month, year] = parts.map(Number);
        if (!day || !month || !year) return '';
        return `${String(day).padStart(2, '0')}-${String(month).padStart(2, '0')}-${year}`;
      }
    }

    return '';
  }


  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  @Input() applyAuthorityFilter = false;
  @Input() tableData: any[] = [];
  @Input() selectedTabName: any[] = [];
  @Output() onAssetNameClick = new EventEmitter<any>();
  @Output() onAssetNameClickInside = new EventEmitter<any>();
  @Output() deleteEmployee = new EventEmitter<any>();

  public gridOptions!: GridOptions;
  public columnDefs: ColDef[] = [];
  mapData: any[] = [];



  ngOnInit(): void {
    // Build mapData from tableData (moved to a reusable method so we can call it on input changes)
    this.rebuildMapData();



    // Parent columns
    this.columnDefs = [
      {
        headerName: 'Asset Name',
        field: 'assetName', // parent field for grouping
        cellRenderer: 'agGroupCellRenderer',
        cellRendererParams: {
          suppressCount: true,
          innerRenderer: (params: any) =>
            `<span style="color:blue;cursor:pointer">${params.value}</span>`,
        },
        width: 200,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Band',
        field: 'band',  // MUST exactly match parent data key
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Allocating Authority',
        field: 'allocatingAuthorityName',
        sortable: true,
        resizable: true,
      },
    ];


    // Grid options
    this.gridOptions = {
      rowData: this.mapData,
      columnDefs: this.columnDefs,
      animateRows: true,
      masterDetail: true,
      isRowMaster: (data: any) => (data.users || []).length > 0,
         // ✅ Add this line — gives access to component instance
      context: { componentParent: this },
      keepDetailRows: true, // keeps details in DOM after collapse (optional)
      detailRowAutoHeight: true,
      // 👇 This ensures no row is expanded by default
      getRowId: (params: any) => params.data.assetName,
      onFirstDataRendered: (params: any) => {
        // ✅ collapse all rows after first render
        params.api.forEachNode((node: any) => node.setExpanded(false));
      },
    
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        sortable: true,
        resizable: true,
        filter: true,            // ✅ enable filter
        headerClass: 'ag-header-cell-label-bold', // ✅ bold header
      },
      detailCellRendererParams: {
        detailGridOptions: {
          // pass parent component reference into the detail grid context
          context: { componentParent: this },
          columnDefs: this.nestedHeaders.map((header) => {
            switch (header.key) {
              case 'currentAssetDescription':
                return {

                  headerName: header.label,
                  field: header.key,
                  filter: 'agSetColumnFilter',
                  minWidth: 210,
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                  cellRenderer: (params: any) => {
                    if (!params.value) return ''; // null/undefined case me blank return karega
                    const shortText = params.value?.length > 30
                      ? params.value.substring(0, 30) + '...'
                      : params.value;

                    return `<span class="clickable-comment">${shortText}</span>`;
                  },
                  onCellClicked: (params: any) => {
                    if (params.value) {
                      console.log(params)
                      params.context.componentParent.openCommentModal(params.value, 'current Asset Description');
                    }
                  } 
                  
                };

              case 'employeeName':
                return {
                  headerName: header.label,
                  field: header.key,
                  cellRenderer: (params: any) =>
                    `<span style="color:blue;cursor:pointer">${params.value}</span>`,
                  flex: 1,
                  minWidth: 180,
                  resizable: true,
                  filter: true,
                };
              case 'allocatingAuthorityName':
                return {
                  headerName: header.label,
                  field: header.key,
                  flex: 1,
                  minWidth: 180,
                  resizable: true,
                  filter: true,
                };

              case 'band': return {
                headerName: header.label,
                field: header.key,
                minWidth: 110,
                resizable: true,
                flex: 1,
                wrapText: true,
                autoHeight: true,
                filter: true,
              };
              case 'authorityDepartment':
                return {
                  headerName: header.label,
                  field: header.key,
                  minWidth: 180,
                  resizable: true,
                  flex: 1,
                  wrapText: true,
                  autoHeight: true,
                  filter: true,
                };

              case 'employeeCommentDate':
              case 'authorityCommentDate':
                return {
                  headerName: header.label,
                  field: header.key,
                  cellRenderer: (params: any) => this.dateRenderer(params),
                  comparator: (valueA: string, valueB: string) =>
                    this.dateComparator(valueA, valueB),
                  filter: 'agDateColumnFilter',
                  sortable: true,
                  minWidth: 240,
                  resizable: true,
                  flex: 1,
                };
              case 'dateOfAllocation':
                return {
                  headerName: header.label,
                  field: header.key,
                  cellRenderer: (params: any) => this.dateRenderer(params),
                  comparator: (valueA: string, valueB: string) =>
                    this.dateComparator(valueA, valueB),
                  filter: 'agDateColumnFilter',
                  sortable: true,
                  minWidth: 180,
                  resizable: true,
                  flex: 1,
                };

              case 'employeeComment':
                return {

                  headerName: header.label,
                  field: header.key,
                  filter: 'agSetColumnFilter',
                  minWidth: 210,
                  cellRenderer: (params: any) => {
                    if (!params.value) return ''; // null/undefined case me blank return karega
                    const shortText = params.value?.length > 30
                      ? params.value.substring(0, 30) + '...'
                      : params.value;

                    return `<span class="clickable-comment">${shortText}</span>`;
                  },
                  onCellClicked: (params: any) => {
                    if (params.value) {
                      console.log(params)
                      params.context.componentParent.openCommentModal(params.value, 'Employee Comment');
                    }
                  } 
                };

              case 'assetRepairTime':
                return {
                  headerName: header.label,
                  field: header.key,
                  cellRenderer: (params: any) =>
                    params.value != null ? `${params.value} days` : '',
                  minWidth: 170,
                  resizable: true,
                  flex: 1,
                };

              case 'action':
                return {
                  headerName: header.label,
                  field: 'action',
                  minWidth: 120,
                  flex: 1,
                  sortable: false,
                  filter: false,
                  resizable: true,
                  cellStyle: { textAlign: 'center' },
                  cellRenderer: () => `<span class="material-icons cp" data-action="delete" style="color:#e53935;cursor:pointer;">delete</span>`,
                };

              case 'authorityDepartmentComment':
                return {
                  headerName: header.label,
                  field: header.key,
                  minWidth: 340,
                  //  editable: true,
                  // cellEditor: 'agSelectCellEditor',
                  valueFormatter: (params:any) => this.formatedataVariable(params.value),
                  headerTooltip: header.label, // optional hover text
                  wrapHeaderText: true,
                  autoHeaderHeight: true
                };
                
              case 'employeeAssetStatus':
                return {
                  headerName: header.label,
                  field: header.key,
                  minWidth: 340,
                  //  editable: true,
                  // cellEditor: 'agSelectCellEditor',
                  cellRenderer: (params: any) => this.statusFormatter(params) ,
                  valueFormatter: (params:any) => this.formatedataVariable(params.value),
                  headerTooltip: header.label, // optional hover text
                  wrapHeaderText: true,
                  autoHeaderHeight: true
                };
              default:
                return {
                  headerName: header.label,
                  field: header.key,
                  minWidth: 150,
                  resizable: true,
                  flex: 0,
                  
                };
            }
          }),
          defaultColDef: {
            resizable: true,
            wrapText: true,
            autoHeight: true,
            flex: 0,
          },

          // Handle cell clicks
          onCellClicked: (event: any) => {
            const clickedColumn = event.colDef.field;
            console.log(clickedColumn);
            
            // Employee name click
            if (clickedColumn === 'employeeName') {
              console.log(event.data);
              this.onAssetNameClickInside.emit(event.data);
            }

            // Delete icon click
            if (clickedColumn === 'action') {
              console.error(event.data);
              
              // ✅ Remove the row from grid and data
              this.deleteRow(event.data);
            }
          },
        },

        getDetailRowData: (params: any) => {
          params.successCallback(params.data.users || []);
        },
      },





      onCellClicked: (event: any) => {
        if (event.colDef.field === 'assetName') this.onAssetNameClick.emit(event.data);
      },
    };
  }

  statusFormatter(params: any): string {
    // Defensive: accept null/undefined and non-string values
    const raw = params && params.value != null ? String(params.value) : '';
    if (!raw) return '';

    // Normalize value: collapse underscores and multiple spaces into single spaces
    const normalized = raw.replace(/[_\s]+/g, ' ').trim();
    const normalizedUpper = normalized.toUpperCase();

    // Status → Color map (keys may contain underscores or spaces in incoming data)
    const statusColors: Record<string, string> = {
      'RECEIVED_ASSET': '#4caf50', // green
      'REPAIR_ASSET': '#4caf50',
      'RETURNING ASSET DUE TO EXIT': '#f44336', // red
      'RECEIVED AFTER REPAIR': '#f44336',
      // 'PENDING_WITH_MANAGER': '#ff9800' // orange
    };

    // Find the best color match by normalizing the keys the same way we normalized the value
    const findMatchKey = () => {
      for (const key of Object.keys(statusColors)) {
        const keyNormalized = key.replace(/[_\s]+/g, ' ').toUpperCase();
        if (normalizedUpper.includes(keyNormalized) || keyNormalized.includes(normalizedUpper)) {
          return key;
        }
      }
      return null;
    };

    const matchKey = findMatchKey();
    const color = matchKey ? statusColors[matchKey] : '#999';

    // Convert normalized text to Title Case for display
    const formattedText = normalized
      .toLowerCase()
      .split(' ')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    // Return HTML string (ag-grid accepts HTML from cellRenderer)
    return `
      <span style="border:1px solid ${color};color:${color};padding:4px 10px;border-radius:12px;font-size:12px;font-weight:500;display:inline-block;white-space:normal;word-wrap:break-word;line-height:1.4em;max-width:100%;">
        ${formattedText}
      </span>`;
  }
  

  deleteRow(rowData: any) {
 
    // Emit event to parent. Parent should perform deletion and then update the
    // `tableData` input (or call an API and refresh data). This component
    // listens for changes to `tableData` and will rebuild the grid.
    this.deleteEmployee.emit(rowData.id);
  }

  // Called when input properties change (e.g. parent updates `tableData` after deletion)
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tableData']) {
      this.rebuildMapData();

      // If grid already initialized, update rows immediately
      try {
        if (this.gridApi && (this.gridApi as any).setRowData) {
          (this.gridApi as any).setRowData(this.mapData || []);
        } else if (this.gridOptions) {
          this.gridOptions.rowData = this.mapData || [];
        }
      } catch (e) {
        // swallow errors silently; not critical
        console.warn('Failed to update AG Grid row data on changes', e);
      }
    }
  }

  // Rebuilds the internal mapData from the provided tableData input
  private rebuildMapData() {
    // defensive guard
    if (!this.tableData || !Array.isArray(this.tableData)) {
      this.mapData = [];
      return;
    }
    console.log("table data in reusable table", this.tableData);
    this.mapData = this.tableData.map((e: any) => ({
      assetName: e.assetName,
      band: Array.isArray(e.band) ? e.band.join(', ') : e.band || e.bands || '',
      allocatingAuthorityName: e.allocatingAuthorityName,
      isRowMaster: (e.users || []).length > 0,
      users: (e.users || [])
        .filter((u: any) => u && u.employeeName)
        .map((u: any) => ({
          employeeName: u.employeeName || '',
          id: u.id || '',
          userId: u.userId || '',
          band: u.band || '',
          assetId: u.assetId || '',
          assetName: e.assetName || '',
          authorityDepartment: u.authorityDepartment || '',
          allocatingAuthorityName: e.allocatingAuthorityName || '',
          dateOfAllocation: e.dateOfAllocation || '',
          currentAssetDescription: u.currentAssetDescription || '',
          employeeAssetStatus: u.employeeAssetStatus || '',
          employeeComment: u.employeeComment || '',
          employeeCommentDate: u.employeeCommentDate || '',
          authorityDepartmentComment: u.authorityDepartmentComment || '',
          authorityCommentDate: u.authorityCommentDate || '',
          assetRepairTime: u.assetRepairTime || 0,
          action: 'delete'
        }))
    }));
  }


  isClicked = false;

resetGrid() {
  this.isClicked = false; // ✅ trigger animation
  setTimeout(() => this.isClicked = true, 10); 

  if (this.gridApi) {
    // ✅ Reset Parent Grid
    this.gridApi.setFilterModel(null);
    this.gridApi.deselectAll();

    this.searchTaskString = '';
    this.gridApi.setGridOption('quickFilterText', '');

    this.paginationPageSize = 10;
    this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
    this.gridApi.paginationGoToFirstPage();

    this.gridApi.refreshCells();
    this.gridApi.resetColumnState();

    // ✅ Reset All Child Grids (expanded rows)
    this.gridApi.forEachDetailGridInfo((detailGridInfo: any) => {
      const childApi = detailGridInfo.api;
      
      if (childApi) {
        childApi.setFilterModel(null);
        childApi.deselectAll();
        childApi.setGridOption('quickFilterText', '');
        
        try {
          childApi.paginationGoToFirstPage();
        } catch {}

        childApi.refreshCells();
        childApi.resetColumnState();
      }
    });
  }
}


  

}

